import { example } from "@/data/example";

// Illustrative follow-through for the public demo only. Never written to a store.
const followThrough = {
  id: {
    nextAction: "Tetapkan ambang utilisasi Jakarta sebelum membuka pusat operasi Surabaya.",
    reviewAt: "2026-11-09",
  },
  en: {
    nextAction: "Set the Jakarta utilisation threshold before opening the Surabaya hub.",
    reviewAt: "2026-11-09",
  },
};

// Public demo wording only. Shared example data and stored user content stay intact.
const displayCopy = {
  id: {
    title: "Pusat operasi Surabaya",
    question: "Apakah pusat operasi Surabaya dibuka kuartal ini, atau ditunda hingga utilisasi Jakarta melewati ambang yang disepakati?",
    cash: "Cadangan kas cukup untuk 11 minggu.",
    lease: "Ketersediaan lokasi sewa di luar penawaran saat ini.",
    conditionalOption: "Buka jika syarat terpenuhi",
    recommendationReason: "Dengan cadangan kas 11 minggu, penundaan menjaga pilihan tetap mudah dibalik.",
    humanRationale: "Cadangan kas belum cukup sebagai penyangga jika peningkatan kapasitas operasional terlambat enam minggu.",
  },
  en: {
    title: "Surabaya operations hub",
    question: "Should we open the Surabaya operations hub this quarter, or wait until Jakarta utilisation exceeds the agreed threshold?",
    cash: "Cash runway: 11 weeks.",
    lease: "Lease availability beyond the current offer.",
    conditionalOption: "Open when conditions are met",
    recommendationReason: "With 11 weeks of cash runway, deferring keeps the decision easier to reverse.",
    humanRationale: "Cash reserves leave too little buffer if the ramp-up is delayed by six weeks.",
  },
};

// Preserve the shared facts, AI recommendation and user choice as separate data.
export function getLandingExample(lang) {
  const locale = lang === "en" ? "en" : "id";
  const source = example[locale];
  const copy = displayCopy[locale];
  return {
    ...source,
    title: copy.title,
    question: copy.question,
    items: source.items.map(item => ({ ...item, text: item.id === "K2" ? copy.cash : item.id === "U1" ? copy.lease : item.text })),
    options: source.options.map(option => ({ ...option, name: option.id === "o2" ? copy.conditionalOption : option.name })),
    brief: { ...source.brief, recommendation: { ...source.brief.recommendation, because: copy.recommendationReason } },
    decision: { ...source.decision, rationale: copy.humanRationale },
    followThrough: followThrough[locale],
  };
}

export function formatLandingReviewDate(date, lang) {
  return new Intl.DateTimeFormat(lang === "en" ? "en-GB" : "id-ID", {
    day: "numeric", month: "long", year: "numeric", timeZone: "UTC",
  }).format(new Date(`${date}T00:00:00Z`));
}
